hierarchy = function (cui_enabled) {

	var objHierarchy = list(null, cui_enabled);
	var objDialog = dialog();
	var objDom = dom(cui_enabled);

	// These objects are needed so that we can refresh the active tab after
	// a hierarchy entity is updated.
	var objEntityTypes = entityTypes();
	var objCommittee = committee();
	var objRoleTypes = roleTypes();

	/**
	 * Sometimes, after updating an entity, the hierarchyEntities tab or the
	 * roles tab will need to be refreshed with an updated canDelete
	 * attrubute, so that it can't be deleted and create bad data.
	 */
	objHierarchy.getFlyout = function(id, type, callback) {
		// check to see if the accounts tab is active
		onAccountsTab = $('.users-tab.active').length > 0;

		// if we are in the accounts module, do not use new flyout code
		if (onAccountsTab){
			$.ajax({
				url: '/admin/hierarchy/flyout',
				type: 'GET',
				data: {id: id, type: type, display: 'flyout'},
				beforeSend: function() {
					objDom.addLoadingMask('#curriculog-summary-column');
					objHierarchy.unbindFlyoutEvents();
					objDom.verticalStretchHierarchy();
				},
				success: function(result) {
					$('#curriculog-summary-column').html(result);
					buildHierarchyDropdown(app, 'entities-available');
					objHierarchy.updateEntityRolesDropDown(id);
					objHierarchy.bindFlyoutEvents();
					bindAccountsFlyoutClickEvents(objHierarchy);

					callback && callback();

					objDom.removeMask('#curriculog-summary-column');
					objDom.adjustFlyout('user-' + id, cui_enabled);
					objHierarchy.verticalStretch();

					Curriculog.Actions.log('account-flyout-loaded')
				}
			});
		} else {
			setupFlyout(type, id, app, callback, cui_enabled);
		}
	};

	objHierarchy.updateEntityRolesDropDown = function(userId) {

		entityId = $('#entities-available option:selected').val();
		$.ajax({
			url: '/admin/entity:' + parseInt(entityId) + '.json',
			type: 'GET',
			success: function(data) {
				
				var roles = data.entity.roles;
				var select = document.getElementById('entity-roles-available');
				var rolesInUse = objHierarchy.getRolesInUse(userId);

				for(var i = 0; i < roles.length; i++) {
					var opt = document.createElement('option');
					opt.innerHTML = roles[i]['name'];
					opt.value = 'role-available-' + roles[i]['id'];
					if (rolesInUse.length > 0 && rolesInUse.includes(roles[i]['id'])) {
						opt.disabled = true;
					}
					select.appendChild(opt);
				}
			}
		});
	};

	objHierarchy.getRolesInUse = function(userId) {

		var rolesInUse = [];

		if($('ul#roles-choosen-' + userId + ' li:not(.no-roles)').size() > 0) {
			$('#roles-choosen-' + userId + ' li:not(.no-roles)').each(function(){
				var roleId = $(this).find('input[name="id"]').val();
				rolesInUse.push(parseInt(roleId));

			});
		}

		return rolesInUse;

	};

	objHierarchy.getAccounts = function(callback) {
		var page = $('#page').val();
		var filterType = $('#sort-by').val();
		var filter = '';

		if (filterType === 'role-type') {
			filter = $('#sort-role-types-available').val();

		} else if (filterType === 'entity') {
			filter = $('#sort-entities-available').val();

		} else {
			if ($('#all-users.active').length > 0) {
				filter = '';
				filterType = '';
			} else {
				filter = $('#name-sort a.active').text();
			}
		}

		$.ajax({
			url: '/admin/account',
			type: 'GET',
			data: {
				page: page,
				filter: filter,
				filterType: filterType,
				showInactive: 1,
				display : 'ajax'
			},
			beforeSend: function() {
				objDom.addLoadingMask('#curriculog-hierarchy-column-content');
				objHierarchy.unbindHierarchyEvents();
			},
			success: function(data) {
				$('#curriculog-hierarchy-column-content').html(data);
				objDom.removeMask('#curriculog-hierarchy-column-content');
				objHierarchy.bindHierarchyEvents();

				objHierarchy.verticalStretch();
				objHierarchy.changeItemVisibility(function (){
					Curriculog.Actions.log('account-list-loaded')
				});

				callback && callback();
			}
		});
	};




/****************************************************************************************************/
/*************************                                                  *************************/
/**********                                                                                **********/
/*****                                      BINDINGS                                            *****/
/**********                                                                                **********/
/*************************                                                  *************************/
/****************************************************************************************************/



	objHierarchy.bindHierarchyEvents = function() {
		objHierarchy.unbindHierarchyEvents();

		// Summary Flyout
		$('#curriculog-hierarchy-column-content').on('click', '.edit-item, .item', function(event) {
			event.preventDefault();
			event.stopPropagation();
			var id = $(this).closest('.item').attr('id');
			// console.log('get the flyout for ' + id);

			objDom.summaryFlyoutHierarchy(id, function(clicked) {
				var type = clicked.split('-');
				$('.summary .summary-title').text($('#' + clicked).find('.'+type[0]+'-name:first').text());
				$('#curriculog-summary-column-content').empty();
				hierarchyObject.getFlyout(type[1], type[0], function(){
          objDom.adjustFlyout(id, cui_enabled);
        }, cui_enabled);
			});
		});

		// Paging
		$('#curriculog-hierarchy-column').on('click', '#curriculog-paging-previous, #curriculog-paging-next', function(event) {
			event.preventDefault();
			accountObject.hideAccountFlyout();

			if ($(this).attr('disabled')) {
				return;
			}

			var page = +$('#page').val();

			if ($(this).attr('id') === 'curriculog-paging-previous') {
				page = page - 1;
			} else {
				page = page + 1;
			}

			$('#page').val(page);

			//hierarchyObject.pageList(page, '', '/admin/accounts');
			hierarchyObject.getAccounts();
		});

		$('#curriculog-hierarchy-column-content').on('click', '.remove-item:not(.disabled):not(.type-replace)', function(event) {
			event.preventDefault();
			event.stopPropagation();

			var type = $(this).closest('.item').attr('id').match(/(.*)-\d*/)[1];

			if (type === 'user') {
				var user = {
					id : $(this).closest('.item').attr('id').replace('user-',''),
					name : $(this).closest('.item').find('.user-name').html(),
					ajax : 'list'
				};

				if ($('#curriculog-hierarchy-column-tabs li.active').attr('class').match(/(\w*)-tab/)[1] === 'users') {
					user.name = $(this).closest('.item').find('input[name="firstName"]').val() + ' ' +  $(this).closest('.item').find('input[name="lastName"]').val();
				}

				accountObject.destroy(user, function(user) {
					// if the deleted user's flyout is open, close it.
					if ($('.summary').hasClass('active')) {
						var summaryId = $('.summary').attr('id').match(/summary-(.*)-(.*)/);
						if ((summaryId[1] === 'user') && (summaryId[2] === user.id)) {
							accountObject.hideAccountFlyout();
						}
					}
					if(user.id == currentUserID){
						location.href = '/';
						return;
					}
					// load the right list
					if ($('#curriculog-hierarchy-column-tabs li.active').attr('class').match(/(\w*)-tab/)[1] === 'users') {
						objHierarchy.getAccounts();
					}
				});
			}
		});

		$('#curriculog-hierarchy-column-content').on('click', '.remove-item.type-replace', _.debounce(function (event) {
			event.preventDefault();
			event.stopPropagation();

			var id = $(this).closest('.item').attr('id').replace('user-','');

			var user = {
				id : id,
				name : $(this).closest('.item').find('.user-name').html(),
				type: 'user'
			};

			accountObject.swapAccountRole(user);
		}, 500));
	};


	objHierarchy.bindFlyoutEvents = function() {
		objHierarchy.unbindFlyoutEvents();

		// Basic Flyout Functionality
		$('#curriculog-summary-column').on('click', '.close-summary', function() {
			var id = $(this).closest('.summary').attr('id').match(/summary-(.*)/);
			domObject.summaryFlyoutHierarchy(id[1], function(clicked) {
				var type = clicked.split('-');
				$('.summary .summary-title').text($('#' + clicked).find('.'+type[0]+'-name').text());
				$('#curriculog-summary-column-content').empty();
				hierarchyObject.getFlyout(type[1], type[0]);
			});
		});

		$('#curriculog-summary-column #relationships').on('click', '.view-widget', function(event) {
			event.preventDefault();
			$(this).closest('li').find('.view-relationship-info').toggleClass('active');
		});

		$('#curriculog-summary-column').on('click', 'button[name="show-help-text"]', function(event) {
			event.preventDefault();
			event.stopPropagation();
			$(this).closest('.summary').find('#help-details').slideToggle(200, function() {
				accountObject.verticalStretchList();
			});
		});


		/********  Entity Flyout Actions *********/


		// Entity Parents
		$('#curriculog-summary-column').on('click', '.entity-parent-remove:not(.disabled)', function(event) {
			event.preventDefault();

			var parentEntityID = $(this).closest('li').find('input').val();
			parentEntityID = parseInt(parentEntityID);

			var currentEntityID = app.flyout.manageParents.currentEntityID;

			var parentEntity = app.entities.get(parentEntityID);
			var currentEntity = app.entities.get(currentEntityID);

			new Curriculog.DeleteDialog({
				itemType: 'parent',
				parentName: parentEntity.getSanitizedModel().get('name'),
				entityName: currentEntity.getSanitizedModel().get('name'),
				callback: function () {
					app.relationships.deleteParent(currentEntity.get('id'), parentEntity.get('id'));
				},

				message: function () {
					msg = 'Are you sure you want to remove <span class="strong">';
					msg += this.parentName;
					msg += '</span> as a parent of ';
					msg += this.entityName;
					msg += '?';
					return msg;
				},
			});
		});

		$('#curriculog-summary-column').on('click', '.entity-parent-remove.disabled', function(event) {
			event.preventDefault();
		});


		/********  Account Flyout Actions *********/

		// User Personal Information
		$('#curriculog-summary-column').on('click', '.change-password:not(.disabled)', function(event) {
			event.preventDefault();
			accountObject.changePassword($(this).parents('.summary').attr('id').replace('summary-user-',''));
		});

		$('#curriculog-summary-column').on('click', '#user-details-isRemote', function(event) {
			if ($(this).is(':checked')) {
				$('.remote-options').show();
				$('.local-options').hide();
			} else {
				$('.remote-options').hide();
				$('.local-options').show();
			}
		});

		// Agenda admin checkbox
		$('#curriculog-summary-column').on('click', '.committee-add-agenda-admin', throttleAjax(function(event) {
			if (this.checked) {
				return objHierarchy.addAgendaAdmin(event);
			} else {
				return objHierarchy.removeAgendaAdmin(event);
			}
		}));

		// User Rights
		$('#curriculog-summary-column').on('click', '.change-pin:not(.disabled)', function(event) {
			event.preventDefault();
			accountObject.updatePin($('#user-details-id').val());
		});

		$('#curriculog-summary-column').on('click', '.change-pin.disabled', function(event) {
			event.preventDefault();
		});
	};

	objHierarchy.unbindHierarchyEvents = function() {
		$('#curriculog-hierarchy-column-content .item').off('click', '.expand-widget');
		$('#curriculog-hierarchy-column-content .item').off('click', '.contract-widget');
		$('#curriculog-hierarchy-column-content').off('click', '.edit-item, .item');
		$('#curriculog-hierarchy-column-content').off('click', '.remove-item:not(.disabled):not(.type-replace)');
		$('#curriculog-hierarchy-column-content').off('click', '.remove-item.type-replace');
		$('#curriculog-hierarchy-column').off('click', '#curriculog-paging-previous, #curriculog-paging-next');
	};

	objHierarchy.unbindFlyoutEvents = function() {
		$('#curriculog-summary-column').off('click', '.close-summary');
		$('curriculog-summary-column #relationships').off('click', '.view-widget');
		$('#curriculog-summary-column').off('click', 'button[name="show-help-text"]');
		$('#curriculog-summary-column').off('click', '.entity-parent-remove:not(.disabled)');
		$('#curriculog-summary-column').off('click', '.entity-parent-remove.disabled');
		$('#curriculog-summary-column').off('click', '#add-role:not(:disabled)');
		$('#curriculog-summary-column').off('click', '.committee-add-agenda-admin');
		$('#curriculog-summary-column').off('click', '.change-pin');
		$('#curriculog-summary-column').off('click', '.add-pin:not(.disabled)');
		$('#curriculog-summary-column').off('click', '.change-password:not(.disabled)');
		$('#curriculog-summary-column').off('click', '.add-pin.disabled');

		unbindAccountsFlyoutClickEvents();
	};

	objHierarchy.verticalStretch = function() {
		objDom.verticalStretchHierarchy();
	};


	objHierarchy.addUserRole = function(userID, roleID) {
		return $.ajax({
			type: 'PUT',
			url: '/admin/account:0/addRole',
			data: {
				user_id: userID,
				role_id: roleID
			},
			beforeSend: function() {
				domObject.addLoadingMask('.summary .summary-content:eq(2)');
			},
			success: function () {
				// we have to make this check because we are not currently loading
				// the roles collection in the accounts module.
				if (app.roles) {
					// update the Backbone model so that our views will refresh
					var role = app.roles.get(roleID);
					app.userRoles.add({
						user_id: userID,
						role_id: roleID,
					}, {
						silent: true,
					});
				}

				Curriculog.Actions.log('user-role-added');
			},
			complete: function (success) {
				domObject.removeMask('.summary .summary-content:eq(2)');

				var summaryId = $('.summary').attr('id').match(/summary-(.*)-(.*)/);
				objHierarchy.getFlyout(summaryId[2], summaryId[1]);

				// load the right list
				if ($('#curriculog-hierarchy-column-tabs li.active').attr('class').match(/(\w*)-tab/)[1] === 'users') {
					objHierarchy.getAccounts();

				}
			}
		});
	};

	objHierarchy.addAgendaAdmin = function(event) {
		var checkbox = event.target,
			committee = $(checkbox).parents('.committee').data(),
			xhr;

		//console.log('Adding user %s as agenda admin', committee.userId);

		// increment the admin count so, that the UI stays in sync, until we reload it.
		committee.adminCount++;

		workload = {
			method_args: {
				userID: committee.userId,
				committeeID: committee.id,
			}
		}

		xhr = $.ajax({
			type: 'POST',
			url: '/gearman-job.json',
			contentType: 'application/json',
			mask: $('#entity-parents-form').parent().parent(),
			data: JSON.stringify({
				functionName: 'add_agenda_admin_task',
				workload: workload
			}),
			beforeSend: function() {
				domObject.addLoadingMask(this.mask);
			},

			success: function (results) {
				getBackgroundJobStatus(results.jobHandle, this.mask, 'Add Agenda Admin', function (jobResults) {
				Curriculog.Actions.log('user-agenda-admin-updated');
			},
			function(jobResults){
				var taskName = 'Add Agenda Admin';
				$('#growls').notify("create","warning-template", {
					title: 'Warning',
					text: 'An error occurred while attempting to ' + taskName + '. Please try again or contact a system administrator.',
				}, {
					expires: false,
				});
			});
			},

			error: function () {
				domObject.removeMask(this.mask);
			},

			complete: function() {
				domObject.removeMask('.itemlist.committees');
			}
		});

		return xhr;
	};

	objHierarchy.removeAgendaAdmin = function(event) {
		var checkbox = event.target,
			committee = $(checkbox).parents('.committee').data(),
			xhr;

		// If there is only one admin, then the user will have to select a replacement.
		if (committee.adminCount === 1) {
			//console.log('There is only one admin left, so you must choose a replacement.');
			var agendaAdmin = {
				committee : committee.id,
				id: committee.userId,
				type: 'user-agenda',
			};
			xhr = accountObject.swapAccountAgendaAdmin(agendaAdmin);
		} else {
			//console.log('Removing user %s as agenda admin', committee.userId);
			workload = {
				method_args: {
					userID: committee.userId,
					committeeID: committee.id,
				}
			}

			xhr = $.ajax({
				type: 'POST',
				url: '/gearman-job.json',
				contentType: 'application/json',
				mask: $('#entity-parents-form').parent().parent(),
				data: JSON.stringify({
					functionName: 'remove_agenda_admin_task',
					workload: workload
				}),
				beforeSend: function() {
					domObject.addLoadingMask(this.mask);
				},

				success: function (results) {
					getBackgroundJobStatus(results.jobHandle, this.mask, 'Remove Agenda Admin', function (jobResults) {
					Curriculog.Actions.log('user-agenda-admin-updated');
				},
				function(jobResults){
					var taskName = 'Remove Agenda Admin';
					$('#growls').notify("create","warning-template", {
						title: 'Warning',
						text: 'An error occurred while attempting to ' + taskName + '. Please try again or contact a system administrator.',
					}, {
						expires: false,
					});
				});
				},

				error: function () {
					domObject.removeMask(this.mask);
				},
				complete: function() {
					domObject.removeMask('.itemlist.committees');
				}
			});
		}

		return xhr;
	};


	return objHierarchy;
};
